import React from "react";
import { Icon } from "@iconify/react";

const WorkspaceKpiIcon = () => (
  <Icon icon="lucide:gauge" width={18} height={18} />
);

export default WorkspaceKpiIcon;
